<template>
  <custom-dialog
    width="1450px"
    class="accounts-payable-dialog"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    :title="title"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float:right; margin-right: 0;">
            <el-input
              v-model="search"
              @input="onPageChange({ page: 1 })"
              :placeholder="$t('fms_accounts_add_account_dialog.htbhjsh')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 更多搜索 -->
          <el-form-item style="float: right">
            <switch-button
              :link="link"
              ref="btn"
            ></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container
        ref="container"
        @search="onPageChange({ page: 1 })"
        @clear="clearFilter()"
      >
        <el-form
          :inline="true"
          label-position="top"
        >
          <el-form-item :label="$t('fms_accounts_add_account_dialog.fu_kuan_dao_qi_ri_qi')">
            <custom-date-picker
              v-model="formSearch.billPaymentTime"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              :init-value="initBillPaymentTime"
              :key="billPaymentTimeKey"
            ></custom-date-picker>
          </el-form-item>
          <div class="half-content">
            <el-form-item
              :label="$t('fms_accounts_add_account_dialog.she_bei_hao')"
              class="half-width"
            >
              <el-input
                v-model="formSearch.deviceNo"
                :placeholder="$t('fms_accounts_add_account_dialog.she_bei_hao')"
                type="number"
                :maxlength="1"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('fms_accounts_add_account_dialog.qi_hao')"
              class="half-width"
            >
              <el-input
                v-model="formSearch.termNum"
                :placeholder="$t('fms_accounts_add_account_dialog.zhi_chi_qu_jian_ru25')"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('fms_accounts_add_account_dialog.xiang_mu')">
            <el-input
              v-model="formSearch.locationName"
              :placeholder="$t('fms_accounts_add_account_dialog.xiang_mu')"
              clearable
            ></el-input>
          </el-form-item>

          <!-- 登记收款看付款公司； 登记付款看收款公司 -->
          <el-form-item
            v-if="!paymentOrReceivable"
            :label="$t('fms_accounts_add_account_dialog.fu_kuan_gong_si')"
          >
            <el-input
              v-model="formSearch.payableOrgName"
              :placeholder="$t('fms_accounts_add_account_dialog.fu_kuan_gong_si')"
              :disabled="formSearch.isAgreementOrder !== '1'"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-else
            :label="$t('fms_accounts_add_account_dialog.shou_kuan_gong_si')"
          >
            <el-input
              v-model="formSearch.receivableOrgName"
              :placeholder="$t('fms_accounts_add_account_dialog.shou_kuan_gong_si')"
              disabled
            ></el-input>
          </el-form-item>
          <!-- 使用统一的是否字典筛选协议订单 -->
          <el-form-item :label="$t('fms_accounts_add_account_dialog.xie_yi_ding_dan')">
            <custom-select
              v-model="formSearch.isAgreementOrder"
              code="isynergy_cloud_bool"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
              @change="onAgreementOrderChange"
            ></custom-select>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          :data="tableList"
          tableCode="fms_add_account_bill"
          type="checkbox"
          v-model="tableSelect"
          @filter="filterChange"
          @sort="sortChange"
          height="500px"
          :slots="['termNum']"
          selectableKey="disabled"
          :filterArr="filterArr"
          :clickSelection="true"
        >
          <template v-slot:termNum="scope">
            {{ scope.row.termNum }}/{{ scope.row.totalTerm }}
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <accounts-footer-sum
          :data="tableSelect"
          :totalPaymentAmount="totalData.totalPaymentAmount"
        ></accounts-footer-sum>
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        :disabled="!tableSelect.length"
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 新增(应收/应付)账款 */

import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';
import accountsFooterSum from '@/pages/fms/components/accounts_footer_sum.vue';
import commonMixin from '../mixins/commonMixin';
import mixins from './mixins';

export default {
  name: '',
  mixins: [dialogMixins, mixins, commonMixin],
  components: { accountsFooterSum },
  props: {
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false,
    },
    // 特定要求的账单类型（请求特定的账单列表）
    requestBillType: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    const initBillPaymentTime = [`${this.$moment().format('YYYY-MM-01')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];

    return {
      initBillPaymentTime: initBillPaymentTime,
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        billPaymentTime: [this.$momentWorld(initBillPaymentTime[0]), this.$momentWorld(initBillPaymentTime[1])],
        deviceNo: '',
        termNum: '',
        locationName: '',
        isAgreementOrder: '',
        payableOrgName: '',
        receivableOrgName: '',
      },
      totalRows: null,
      tableList: [],
      tableSelect: [],
      search: '',
      link: null,
      // 账单金额统计
      totalData: {
        totalPaymentAmount: 0,
      },
      billPaymentTimeKey: 1,
    };
  },
  computed: {
    billType() {
      return this.model.data ? this.model.data.billType : '';
    },
    title() {
      if (this.model.title) {
        return this.model.title;
      }
      const map = {
        add: this.$t('fms_accounts_add_account_dialog.tian_jia_zhang_dan'),
        edit: this.$t('fms_accounts_add_account_dialog.bian_ji_zhang_dan'),
      };
      return map[this.model.type];
    },
    // 是否为库存管理费
    isStock() {
      return `${this.billType}` === `${this.dicMap.bill_type.stock}`;
    },
    filterArr() {
      // 登记收款看付款公司，登记付款看收款公司
      if (this.paymentOrReceivable) {
        // 付款登记
        return ['payableOrgName'];
      } else {
        return ['receivableOrgName'];
      }
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 非协议订单沿用原逻辑，不允许按付款公司筛选
    onAgreementOrderChange() {
      if (this.formSearch.isAgreementOrder !== '1') {
        this.formSearch.payableOrgName = '';
      }
    },
    getTotalAmount(row) {
      const { paymentAmount = 0, breakAmount = 0 } = row;
      return paymentAmount + breakAmount;
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 获取账单金额统计
    getReceivableTotal(reqData) {
      const rData = reqData || this.getReqData();
      this.$getJSON(apis.paymentToAddPayableTotal, rData).then((res) => {
        this.totalData = res.data || {};
      });
    },
    getReqData() {
      let times = {};
      const billPaymentTime = this.formSearch.billPaymentTime;
      if (billPaymentTime && billPaymentTime.length) {
        times = {
          beginOfPaymentTime: billPaymentTime[0],
          endOfPaymentTime: billPaymentTime[1],
        };
      }
      const { billTradeState, payableOrgId, receivableOrgId, filterBillIdList = [] } = this.model.data;
      const data = {
        billTradeState,
        payableOrgId,
        receivableOrgId,
        filterBillIdList,
      };
      delete data.billType;
      const reqData = {
        ...this.formSearch,
        ...data,
        ...{ search: this.search, keyword: this.search },
        ...times,
        paymentOrReceivable: this.paymentOrReceivable,
      };

      if (this.requestBillType && this.requestBillType.length) {
        reqData.billType = [...this.requestBillType];
      }

      if (reqData.termNum) {
        reqData.termNum = this.formatTermNum(reqData.termNum);
      }

      return reqData;
    },
    getTableList() {
      const reqUrl = apis.paymentToAddPayablePage;
      const reqData = this.getReqData();
      const termNum = this.formSearch.termNum;
      // 是否为纯数字的字符串
      const testPureNum = /^\d+$/;
      // 是否为 1-3 格式的字符串
      const testRangeNum = /^\d+\-\d+$/;
      if (termNum) {
        const isPureNum = testPureNum.test(termNum);
        const isRangeNum = testRangeNum.test(termNum);
        if (!isPureNum && !isRangeNum) {
          this.$message.error(this.$t('fms_accounts_add_account_dialog.qsrhfqh'));
          return;
        }
      }
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.tableList = this.formatRefundBill(res.data.records || res.data.list);
        this.totalRows = res.data.total;
      });
      this.getReceivableTotal(reqData);
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.tableSelect);
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      // 然后日期组件重新根据init-value赋值
      this.billPaymentTimeKey++;
      setTimeout(() => {
        this.onPageChange({ page: 1 });
      }, 300);
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.link = this.$refs.container;
      setTimeout(() => {
        this.$refs.btn.onClick();
      }, 100);
    }, 100);
    // const data = this.model.data;
    // this.formSearch.payableOrgName = data.payableOrgName;
    // this.formSearch.receivableOrgName = data.receivableOrgName;
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getDicMap('bill_type', () => {
      this.getTableList();
    });
  },
};
</script>

<style lang="scss">
.accounts-payable-dialog {
  .dialog-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .half-content {
    width: 25%;
    display: inline-block;
  }

  .half-width {
    width: 50% !important;
  }
}
</style>
